import { useMemo } from 'react'
import './../../../../../../../sinapsi/style/price-calendar.sinapsi.css'
import '../style/rr-bulk-edit-cc.css'
import { ReservedResourceF } from '../../../../../types/reservation-detail.types'
import useLocalizeString from 'src/app/hooks/current-locale/use-localized-string'
import { useTranslation } from 'react-i18next'

type RRBulkEditChargeCategoriesGridFirstCellProps = {
  reservedResource: ReservedResourceF
}

export default function RRBulkEditChargeCategoriesGridFirstCell({ reservedResource }: RRBulkEditChargeCategoriesGridFirstCellProps) {
  const { t } = useTranslation()
  const localizeString = useLocalizeString()
  const resourceOccupancy = useMemo(() => {
    return reservedResource.resourceOccupancies.length > 0 ? reservedResource.resourceOccupancies[0] : undefined
  }, [reservedResource])

  const rtCode = useMemo(() => {
    const tmpRt = resourceOccupancy?.reservedResourceType
    if (tmpRt?.code) return tmpRt?.code
    if (tmpRt?.customName) return localizeString(tmpRt.customName)
    if (tmpRt?.description) return localizeString(tmpRt.description)
    return ''
  }, [resourceOccupancy])

  const resourceCode = useMemo(() => {
    return resourceOccupancy?.resource?.code
  }, [resourceOccupancy])

  const text = useMemo(() => {
    if (resourceCode) return `${resourceCode} (${rtCode})`
    return rtCode
  }, [rtCode, resourceCode])

  const occupancy = useMemo(() => {
    return reservedResource.children
      ? t('pms.booking.reservation.rr_bulk_edit_cc_drawer.adults_children', { adults: reservedResource.adults, children: reservedResource.children })
      : t('pms.booking.reservation.rr_bulk_edit_cc_drawer.adults', { adults: reservedResource.adults })
  }, [reservedResource])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <p className="small-font rr-name" style={{ textAlign: 'center', margin: '0px' }}>
        <b>{text}</b>
      </p>

      <p className="small-font" style={{ textAlign: 'center', margin: '0px', marginTop: '4px' }}>
        {occupancy}
      </p>
    </div>
  )
}
